import React, { useState, useEffect } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "../../axiosInstance";
import Grid from "apollo-react/components/Grid";
import Button from "apollo-react/components/Button";
import Typography from "apollo-react/components/Typography";
import { Form, withFormik } from "formik";
import { FormikTextField, FormikPasswordInput } from "../common/FormikComponent";
import Info from "apollo-react-icons/Info";
import validate from "./login_validation";
import AuthLayout from "./AuthLayout";

const initialValues = {
	email: "",
	password: "",
};

const onFormSubmit = async (
	values,
	{ setSubmitting, setFieldError, props }
) => {
	const resp = await axios.post("/api/auth/login", values);
	if (props.navigate) {
		props.navigate(`/${resp.data.role}/home`);
	}
	setSubmitting(false);
};

const Login = (props) => {
	const {
    // values,
    // errors,
    // touched,
		setFieldValue,
    // setFieldTouched,
    // setFieldError,
    // onFormSubmit,
    // isSubmitting,
    content
	} = props;

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		if (content) {
			Object.keys(content).forEach((key) => {
				if (initialValues.hasOwnProperty(key)) {
					setFieldValue(key, content[key]);
				}
			});
		}
		setLoading(false);
	}, [content, setFieldValue]);

	return loading ? (
		<Typography variant="body2" style={{ margin: "8px 0" }}>
			{"Loading..."}
		</Typography>
	) : (
		<div className="page-container">
			<AuthLayout>
				{/* Mobile Content - Only visible when left image is hidden */}
				<div className="mobile-content">
					<div className="mobile-hero">
						<h1 className="mobile-title">Drug Registration System (D.R.S)</h1>
						<p className="mobile-description">
							IQVIA's Drug Registration System (DRS) is a centralized, cloud-based platform designed to streamline the entire drug registration lifecycle—from submission to approval—while ensuring regulatory compliance and operational efficiency.
						</p>
					</div>
				</div>
				
				<Grid container justifyContent="center" className="signInTitleGrid">
					<div>
						<h2 className="signInTitle">Sign In</h2>
						<p className="signInDesc">
							Log in by entering your email address and password.
						</p>
					</div>
				</Grid>
			<Grid container className="formContainer">
				<Grid container justifyContent="center">
					<Grid item xs={12}>
						<Form noValidate>
							<FormikTextField
								name="email"
								type="email"
								label={
									<span className="formLabelWithIcon">
										Email Address
										<Info fontSize="extraSmall" style={{ color: "#595959" }} />
									</span>
								}
								key="name"
								autoFocus
								fullWidth
								onPaste={(e) => {
									e.preventDefault();
									const text = e.clipboardData.getData("text").trim();
									props.setFieldValue("email", text);
								}}
							/>
							<FormikPasswordInput
								name="password"
								label={
									<span className="formLabelWithIcon">
										Password
										<Info fontSize="extraSmall" style={{ color: "#595959" }} />
									</span>
								}
								fullWidth
								onPaste={(e) => {
									e.preventDefault();
									const text = e.clipboardData.getData("text").trim();
									props.setFieldValue("password", text);
								}}
							/>
							<Grid container justifyContent="space-between">
								<Grid item>
									<a href="/" className="forgotPassword">
										Forgot password?
									</a>
								</Grid>
							</Grid>
							<Button variant="primary" className="loginButton" type="submit">
								Login
							</Button>
						</Form>
					</Grid>
				</Grid>
				<Grid container textAlign="center">
					<a className="ssoLink" href="/sso">
						Sign in with SSO
					</a>
				</Grid>
			</Grid>
			<Grid container justifyContent="center">
				<p className="signUpText">
					Sign up as an Enduser?{" "}
					<a href="/customer/register" className="signUpLink">
						Sign up here
					</a>
				</p>
			</Grid>
		</AuthLayout>
		</div>
	);
};

const FormikLogin = withFormik({
	validate,
	mapPropsToValues: () => initialValues,
	handleSubmit: onFormSubmit,
	validateOnChange: false,
	validateOnBlur: false,
})(Login);

export default function LoginWithNavigate(props) {
	const navigate = useNavigate();
	return <FormikLogin {...props} navigate={navigate} />;
}
